
import { countries } from '@/config/i18n/countries'
import { defineComponent, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import LanguageMenu from '@/components/layout/header/menu/LanguageMenu.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'header-navbar',
  components: {
    // KTSearch,
    LanguageMenu
  },
  setup () {
    const store = useStore()
    const i18n = useI18n()

    const themeMode = computed(() => {
      return store.getters.getThemeMode
    })

    const currentLanguageLocale = computed(() => {
      return countries[i18n.locale.value]
    })

    return {
      themeMode,
      currentLanguageLocale
    }
  },
  computed: {
    user () {
      return useStore().getters.getUser
    }
  }
})
